import { Injectable } from '@angular/core';
import { ApifirstService } from './apifirst.service';
import { RpcClientService } from './rpc-client.service';
import { SbdoApiService } from './sbdo-api.service';

/**
 * Utility class for compatibility check
 */

@Injectable({
  providedIn: 'root'
})
export class FdrsVersionCheckerService {

  _REFRESH_INTERVAL = 2 * 60 * 1000;
  _FDRS_VERSION_CHECK_KEY = 'FDRS_VERSION_CHECK';

  constructor(private sbdoApiService: SbdoApiService, private service: ApifirstService) { }


  isCompatibleVersion() {
    return this._loadStatus().compatible;
  }

  checkCompatibility(connectedVersion: any, callback: any, rpcClient: RpcClientService ) {
    var currentStatus = this._loadStatus();
    if (this._isRefreshRequired(currentStatus)) {
      this._getStatus(connectedVersion, callback, rpcClient);
    }
    else {
      callback(currentStatus.compatible);
    }
  }

  _getStatus(connectedVersion: any, callback: any, rpcClient: RpcClientService) {
    // Check for impl. in the SBDO WS controller source
    //EtisSbdoWebService.GFDRS.checkCompatibility(connectedVersion, callback, _storeStatus);
    // ??? - add api call later
    // this.sbdoApiService.checkCompatibility(connectedVersion);
    this.service.checkFDRSCompabality(connectedVersion).subscribe((data)=> {
      let parsestr = JSON.parse(data);
      var compatible;
      if(parsestr.status[0] == 'success'){
       compatible = true;
      } else {
        compatible = false;
      }

      // var compatible = data === 'success';
      if(compatible) {
        callback(compatible,"",rpcClient);
      } else {
        callback(compatible,parsestr.status[1],rpcClient);
      }
    })
  }

  _loadStatus() {
    var status: any = window.localStorage.getItem(this._FDRS_VERSION_CHECK_KEY);
    if (status == null) {
      status = { compatible: false, updated: new Date(0) };
    }
    else {
      status = JSON.parse(status);
    }
    return status;
  }

  _storeStatus(compatibilityStatus: any) {
    var status = { compatible: compatibilityStatus, updated: new Date() };
    window.localStorage.setItem(this._FDRS_VERSION_CHECK_KEY, JSON.stringify(status));
  }

  _isRefreshRequired(status: any) {
    // ??? 
    // return new Date(status.updated) < new Date(new Date() - this._REFRESH_INTERVAL);
    return new Date(status.updated) < new Date(new Date().valueOf()- this._REFRESH_INTERVAL);
  }

}
